import styled from "styled-components";

const Title = styled.label`
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const Spacer = styled.div`
  width: 100%;
  border-top: 1px solid white;
  opacity: 12%;
  margin-top: 26px;
`;

const InfoWrapper = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
`;

const InfoText = styled.label`
  text-align: start;
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  color: ${(props) => props.theme.color.text.primary};
`;

const InfoIcon = styled.img`
  &:hover {
    cursor: pointer;
    opacity: 80%;
  }
`;

const Grid = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 8px;
  row-gap: 8px;
`;

export { Title, Spacer, InfoWrapper, InfoText, InfoIcon, Grid };
